import { CommonImages } from "../../../../reusableUI/images";
import { useLocation } from "react-router-dom";
import { useState } from "react";
import { IoIosClose } from "react-icons/io";
import { contractSubmit } from "../../../../Service/RM";
import { useNavigate } from "react-router-dom";
import StepProgress from "./steprogress";
import { showToast } from "../../../../reusableUI/toaster";
import secureLocalStorage from "react-secure-storage";

const Agreement = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const searchParams = new URLSearchParams(location.search);
  const hospitalIdEncoded = searchParams.get("hospitalid");
  const [isPopupVisible, setIsPopupVisible] = useState(false);
  const [fullName, setFullName] = useState("");
  const [isChecked, setIsChecked] = useState(false);
  const [toastMsg, setToastMsg] = useState(null);

  const handleAgreeClick = () => {
    setIsPopupVisible(true);
  };

  const handleClosePopup = () => {
    setIsPopupVisible(false);
  };

  const handleCheckboxChange = () => {
    setIsChecked(!isChecked);
  };

  const handleFullNameChange = (e) => {
    const value = e.target.value;
    const capitalized = value
      .toLowerCase()
      .replace(/\b\w/g, (char) => char.toUpperCase());
    setFullName(capitalized);
  };

  let hospitalId = null;
  if (hospitalIdEncoded) {
    try {
      hospitalId = window.atob(hospitalIdEncoded);
      // console.log(hospitalId);
    } catch (error) {
      console.error("Invalid hospital id encoding", error);
    }
  }

  const handleConfirm = async () => {
    if (!fullName || !isChecked) {
      showToast("Please enter your full name and agree to the terms.", "Error");
      return;
    }

    const data = {
      signedBy: fullName,
    };

    try {
      const res = await contractSubmit(data);

      if (res.error === false) {
        console.log(res.data);
        handleClosePopup();

        showToast("Contract Signed Successfully", "Success");

        if (res.data?.paymentInfo?.paid === false) {
          secureLocalStorage.setItem("contractSigned", true);
          navigate("/membership", {
            state: { userData: res.data },
          });
        }
      } else {
        console.error(res?.message);
        showToast(res?.message || "Failed to sign contract.", "Error");
      }
    } catch (error) {
      console.error(error);
      showToast("Something went wrong while signing contract.", "Error");
    }
  };

  const handleLogout = () => {
    secureLocalStorage.removeItem("isAuth");
    secureLocalStorage.removeItem("isAuthHospital");
    secureLocalStorage.clear();
    localStorage.clear();

    navigate("/parter/login");
  };

  return (
    <div className="bg-[#4951EC] flex flex-col justify-center items-center min-h-screen ">
      <StepProgress currentStep={0} />
      <div className="bg-white rounded-sm w-[75%] shadow-lg p-2 h-[88vh] flex flex-col gap-3 ">
        <div className="overflow-y-auto p-4 font-roboto text-gray-800 scrollbar-thin scrollbar-thumb-[#4951EC] scrollbar-track-gray-200">
          <img
            src={CommonImages.CevIcon}
            alt="Ceviliyar Logo"
            className="w-[145px] h-[36px] mx-auto"
          />
          <p className="text-[20px] font-poppins font-bold text-[#4951EC] mb-2 mt-8 mb-2">
            Contract signging
          </p>
          <p className="text-base font-semibold mb-4 font-poppins">
            Your Agreement
          </p>
          <p className="text-sm leading-6 font-poppins">
            <strong>Last Revised:</strong> April 24, 2025 <br />
            <br />
            Welcome to www.lorem-ipsum.info. This site is provided as a service
            to our visitors and may be used for informational purposes only.
            Because the Terms and Conditions contain legal obligations, please
            read them carefully.
            <br />
            <br />
            <strong>1. YOUR AGREEMENT</strong> <br />
            By using this Site, you agree to be bound by, and to comply with,
            these Terms and Conditions. If you do not agree to these Terms and
            Conditions, please do not use this site.
            <br />
            <br />
            <em>PLEASE NOTE:</em> We reserve the right, at our sole discretion,
            to change, modify or otherwise alter these Terms and Conditions at
            any time. Unless otherwise indicated, amendments will become
            effective immediately. Please review these Terms and Conditions
            periodically. Your continued use of the Site following the posting
            of changes and/or modifications will constitute your acceptance of
            the revised Terms and Conditions and the reasonableness of these
            standards for notice of changes. For your information, this page was
            last updated as of the date at the top of these terms and
            conditions.
            <br />
            <br />
            <strong>2. PRIVACY</strong> <br />
            Please review our Privacy Policy, which also governs your visit to
            this Site, to understand our practices.
            <br />
            <br />
            <strong>3. LINKED SITES</strong> <br />
            This Site may contain links to other independent third-party Web
            sites ("Linked Sites”). These Linked Sites are provided solely as a
            convenience to our visitors. Such Linked Sites are not under our
            control, and we are not responsible for them.
            <strong></strong> <br />
            Please review our Privacy Policy, which also governs your visit to
            this Site, to understand our practices.
            <br />
            <br />
            <strong>3. LINKED SITES</strong> <br />
            This Site may contain links to other independent third-party Web
            sites ("Linked Sites”). These Linked Sites are provided solely as a
            convenience to our visitors. Such Linked Sites are not under our
            control, and we are not responsible for them.
          </p>
        </div>
        <div className="sticky bottom-0 left-0 w-full bg-white py-3 px-4 border-t border-gray-300 flex justify-end gap-4">
          <button
            onClick={handleLogout}
            className="px-4 py-1 border text-[12px] border-gray-400 rounded-md text-gray-700 hover:bg-gray-100 font-poppins"
          >
            Cancel
          </button>
          <button
            className="bg-custom-gradient px-4 py-1  text-white rounded-md hover:bg-[#3942c0] text-[12px] font-poppins"
            onClick={handleAgreeClick}
          >
            Agree
          </button>
        </div>
      </div>
      {isPopupVisible && (
        <div className="fixed inset-0 bg-gray-600 bg-opacity-50 flex justify-center items-center">
          <div className="bg-white p-6 rounded-sm shadow-lg max-w-sm w-full">
            <div className="flex flex-row items-center justify-between mb-4">
              <h2 className="text-[16px] font-semibold text-center font-poppins">
                Confirmation
              </h2>
              <div onClick={handleClosePopup} className="cursor-pointer">
                <IoIosClose size={22} />
              </div>
            </div>
            <p className="mb-4 text-[13px] font-poppins">
              Please provide your full name and confirm your agreement.
            </p>

            <div className="mb-4">
              <label
                className="block text-[13px] font-semibold mb-2 font-poppins"
                htmlFor="fullName"
              >
                Full Name
              </label>
              <input
                id="fullName"
                type="text"
                value={fullName}
                onChange={handleFullNameChange}
                className="w-full px-3 py-2 border border-gray-300 rounded-md text-[13px] font-poppins"
                placeholder="Enter your full name"
              />
            </div>

            <div className="flex items-center mb-4">
              <input
                type="checkbox"
                id="termsCheckbox"
                checked={isChecked}
                onChange={handleCheckboxChange}
                className="mr-2 h-4 w-4"
              />
              <label
                htmlFor="termsCheckbox"
                className="text-[13px] font-poppins "
              >
                I hereby accept and agree to all the terms outlined in the
                contract.
              </label>
            </div>

            <div className="flex justify-around">
              <button
                onClick={handleConfirm}
                className="bg-custom-gradient px-4 py-2 bg-[#4951EC] text-white rounded-md hover:bg-[#3942c0] text-[13px] font-poppins"
              >
                Submit
              </button>
            </div>
          </div>
        </div>
      )}
      {/* {toastMsg && <Toaster action={toastMsg.action} msg={toastMsg.msg} />} */}
    </div>
  );
};
export default Agreement;
